import { render } from "./KardexIndividualView.vue?vue&type=template&id=509a2502&ts=true"
import script from "./KardexIndividualView.vue?vue&type=script&lang=ts"
export * from "./KardexIndividualView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__